module.exports = __webpack_public_path__ + "img/order_empty@2x.d7464971.png";